const getters = {
  
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nickname: state => state.user.nickname
 
}
export default getters
